module.exports = __webpack_public_path__ + "images/application/promo/comic-book-ruthy@2x-29cbe903.png";